import $ from 'jquery';
import * as Website from '../Config/Website.js';

const FooterMargin = () => {

  // ウィンドウ幅 576 以下だけ発火
  if (Website.status.winWidth <= 576) {
    const sp_menu = $('.js-SPnav').outerHeight();
    $('footer').css('margin-bottom', sp_menu + 'px');
  } else {
    // それ以外は margin-bottom をリセットするならこちら
    $('footer').css('margin-bottom', '');
  }
};

export default FooterMargin;
